/* eslint-disable import/no-unresolved */
import { useQuery } from '@apollo/client';

import {
    GET_FILTERED_FILE_DATA,
} from 'Apollo/Queries/DataRecon/DataConfiguration';

/* apollo query to fetch filtered data of selected file of given project */
export const GetFileData = (fileName, projectId, nodeId) => {
    const { data, loading, error } = useQuery(GET_FILTERED_FILE_DATA, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                fileName,
                projectId,
                nodeId,
                batchTestProjectId: projectId,
            },
        },
    });
    let fileData = [];
    if (!loading && !error) {
        fileData = data && data.getFilterPreviewData ? data.getFilterPreviewData.fileData : [];
    }
    return {
        fileData,
        isFileDataLoading: loading,
        isFileDataError: error,
    };
};

export const DATA_PREVIEW = '';
